import {ScrollTrigger} from "../utils/vendor.js";

let header, logo;

export default class HeaderComponent {
    constructor() {
        header = document.querySelector(".js-header");

        if (!header) {
            return;
        }

        logo = document.getElementById("logo")

        if (logo) {
            logo.addEventListener("mouseenter", () => logo.stop());
            logo.addEventListener("mouseleave", () => logo.play());
        }
    }

    init() {
        ScrollTrigger.create({
            trigger: document.body,
            start: "top top",
            end: "bottom bottom",
            onUpdate: ({direction}) => {
                if (!document.documentElement.classList.contains("is-menu")) {
                    header.classList.toggle("-hidden", direction === 1);
                }
            }
        });
    }

    beforeTransition() {
        header?.classList.remove("-hidden");
    }
}
